import { render, staticRenderFns } from "./vxie.vue?vue&type=template&id=5bf0078b&scoped=true&"
import script from "./vxie.vue?vue&type=script&lang=js&"
export * from "./vxie.vue?vue&type=script&lang=js&"
import style0 from "./vxie.vue?vue&type=style&index=0&id=5bf0078b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf0078b",
  null
  
)

export default component.exports